/* src/app/shared/components/consolidation-filter/consolidation-filter.component.scss */
.consolidation-filter {
  width: 250px;
  margin-right: 5px;
}
.consolidation-filter .form-control {
  height: 40px;
  font-size: 0.8rem;
}
/*# sourceMappingURL=consolidation-filter.component.css.map */
